import { useMemo } from 'react';
import { object, string } from 'yup';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { IGuestBookingFormData } from '../types/IGuestBookingFormData';

export function useGuestBookingSchema() {
	const { t } = useTranslation();

	const schema = useMemo(
		() =>
			object<IGuestBookingFormData>({
				email: string()
					.email(t('user_form_email_pattern_error'))
					.required(t('email_form_field_error')),
				reference: string().required(t('booking_reference_form_field_error')),
			}).required(),
		[t],
	);

	return schema;
}
